import { CmsObjectWithDefault } from '@components/Cms/types';

export type OtpOptionsFormViewCmsKey =
    | 'selectVerificationMethod'
    | 'phoneSMSOTPOption'
    | 'emailOTPOption'
    | 'disclaimer'
    | 'title'
    | 'phoneNumberRequired'
    | 'pleaseAddPhoneNumber';

export const OtpOptionsFormViewCmsWithDefault: CmsObjectWithDefault<OtpOptionsFormViewCmsKey> = {
    selectVerificationMethod: {
        cmsId: 327258,
        defaultTranslation: 'Select a verification method to continue:',
    },
    phoneSMSOTPOption: {
        cmsId: 327259,
        defaultTranslation: 'via Text message (SMS)',
    },
    emailOTPOption: {
        cmsId: 327260,
        defaultTranslation: 'via Email',
    },
    disclaimer: {
        cmsId: 327261,
        defaultTranslation: 'Two step verification process to improve security on your account',
    },
    title: {
        cmsId: 327262,
        defaultTranslation: 'Please verify your identity',
    },
    phoneNumberRequired: {
        cmsId: 327329,
        defaultTranslation: 'Phone number required',
    },
    pleaseAddPhoneNumber: {
        cmsId: 327330,
        defaultTranslation: 'To receive your OTP by SMS, please add a mobile phone number to the User Management page.',
    },
};
